import Listings from "@realtorSitesClient/pages/Listings";
import { createFileRoute } from "@tanstack/react-router";

import { z } from "zod";

const listingsSearchSchema = z.object({
  city: z.string().optional(),
  subdivision: z.string().optional(),
  propertyType: z.string().optional(),
  q: z.string().optional(),
  showFilters: z.boolean().optional(),
  view: z.enum(["grid", "table"]).optional(),
});

type ListingsSearch = z.infer<typeof listingsSearchSchema>;

export const Route = createFileRoute("/listings/")({
  validateSearch: (search) => listingsSearchSchema.parse(search),
  component: RouteComponent,
});

function RouteComponent() {
  return <Listings />;
}
